(function(){
  if(window.__hmTa) return; window.__hmTa=true;
  window.addEventListener('pageshow',function(e){if(e.persisted&&document.querySelector('[data-ta-product]'))location.reload();});
  var $=function(s,r){return (r||document).querySelector(s)}, $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var root_=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

  function product(root){
    var data=JSON.parse($('[data-ta-data]',document).textContent);
    var fmt; try{fmt=new Intl.NumberFormat(data.locale,{style:'currency',currency:data.currency});}catch(e){fmt=new Intl.NumberFormat('fr-CH',{style:'currency',currency:data.currency||'CHF'});}
    function money(c){if(data.currency==='CHF')return 'CHF '+(c/100).toFixed(2);return fmt.format(c/100).replace(/\u00a0|\u202f/g,' ');}
    var st={c:data.start,qty:1,pillow:false,busy:false};
    var track=$('[data-ta-track]',root);
    var sws=$$('[data-ta-sw]',root), form=$('[data-ta-form]',root), msg=$('[data-ta-msg]',root);
    var atcs=[$('[data-ta-atc]',root),$('[data-ta-atc2]',root)].filter(Boolean);
    var ups=$('[data-ta-ups]',root), upsIn=$('[data-ta-ups-in]',root);
    function vOf(c){return data.v.filter(function(v){return v.c===c})[0];}
    function pOf(c){return data.pv.filter(function(v){return v.c===c})[0];}
    function groupOf(c){return data.groups[c]||'all';}

    // Galerie : photos de la couleur choisie
    var slides=$$('[data-ta-slide]',track), thumbs=$$('[data-ta-thumb]',root);
    function visibleSlides(){return slides.filter(function(s){return !s.hidden;});}
    function idx(){var vs=visibleSlides(),best=0,bd=1e9;vs.forEach(function(s,i){var d=Math.abs(s.offsetLeft-track.scrollLeft);if(d<bd){bd=d;best=i;}});return best;}
    function go(i){var vs=visibleSlides();i=Math.max(0,Math.min(vs.length-1,i));if(vs[i])track.scrollTo({left:vs[i].offsetLeft,behavior:'smooth'});}
    function markThumbs(){var vs=visibleSlides(),cur=vs[idx()];thumbs.forEach(function(t,i){t.setAttribute('aria-current',slides[i]===cur?'true':'false');});}
    function filterGallery(){
      var g=groupOf(st.c);
      slides.forEach(function(s,i){var on=(s.getAttribute('data-g')==='all'||s.getAttribute('data-g')===g);s.hidden=!on;if(thumbs[i])thumbs[i].hidden=!on;});
      track.scrollTo({left:0,behavior:'auto'});markThumbs();
    }
    track.addEventListener('scroll',markThumbs,{passive:true});
    $('[data-ta-prev]',root).addEventListener('click',function(){go(idx()-1);});
    $('[data-ta-next]',root).addEventListener('click',function(){go(idx()+1);});
    thumbs.forEach(function(t,i){t.addEventListener('click',function(){var s=slides[i];if(s&&!s.hidden){go(visibleSlides().indexOf(s));}});});

    function totals(){
      var v=vOf(st.c)||data.v[0], p=pOf(st.c), pct=data.pct;
      var withP=!!(st.pillow&&p&&p.a);
      var unit=withP?Math.round((v.p+p.p)*(100-pct)/100):v.p;
      return {v:v,p:p,unit:unit,total:unit*st.qty,withP:withP,old:p?v.p+p.p:0,nw:p?Math.round((v.p+p.p)*(100-pct)/100):0};
    }
    function render(){
      var t=totals(), v=t.v;
      sws.forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-ta-sw')===st.c?'true':'false');});
      var cl=$('[data-ta-clabel]',root); if(cl)cl.textContent=st.c;
      var pr=$('[data-ta-price]',root); if(pr)pr.textContent=money(v.p);
      var ok=!!(v&&v.a);
      atcs.forEach(function(b){b.classList.toggle('is-off',!ok);b.disabled=st.busy;b.textContent=ok?(b.getAttribute('data-label')+' · '+money(t.total)):b.getAttribute('data-off');});
      var p2=$('[data-ta-price2]',document); if(p2)p2.textContent=money(t.total);
      $('[data-ta-qty]',root).textContent=st.qty;
      if(ups){
        var p=t.p; ups.hidden=!(p&&p.a);
        if(p){var im=$('[data-ta-ups-img]',ups);if(im&&p.i&&im.getAttribute('data-c')!==st.c){im.src=p.i;im.setAttribute('data-c',st.c);}
          $('[data-ta-ups-old]',ups).textContent=money(t.old);$('[data-ta-ups-new]',ups).textContent=money(t.nw);}
      }
      // set (autre section)
      var so=$('[data-ta-setold]',document), sn=$('[data-ta-setnew]',document);
      if(sn&&t.p){sn.textContent=money(t.nw);if(so)so.textContent=money(t.old);}
      var g=groupOf(st.c);
      $$('[data-ta-setimg]',document).forEach(function(el){el.hidden=el.getAttribute('data-ta-setimg')!==(g==='noir'?'noir':'or');});
      var sb=$('[data-ta-setadd]',document); if(sb)sb.disabled=!(t.p&&t.p.a&&ok)||st.busy;
    }
    sws.forEach(function(b){b.addEventListener('click',function(){
      if(b.hasAttribute('data-off'))return;
      st.c=b.getAttribute('data-ta-sw');msg.textContent='';filterGallery();render();
    });});
    $('[data-ta-minus]',root).addEventListener('click',function(){st.qty=Math.max(1,st.qty-1);render();});
    $('[data-ta-plus]',root).addEventListener('click',function(){st.qty=Math.min(10,st.qty+1);render();});
    if(upsIn)upsIn.addEventListener('change',function(){st.pillow=upsIn.checked;render();});

    function add(withPillow){
      var t=totals(); if(!t.v||!t.v.a||st.busy)return;
      var items=[{id:t.v.id,quantity:st.qty}];
      if(withPillow){if(!t.p||!t.p.a)return;items.push({id:t.p.id,quantity:st.qty});}
      st.busy=true;render();msg.textContent='';
      fetch(root_+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){if(!r.ok)throw 0;return r.json();})
        .then(function(){location.href=withPillow&&data.code?(root_+'discount/'+encodeURIComponent(data.code)+'?redirect='+encodeURIComponent(root_+'cart')):(root_+'cart');})
        .catch(function(){st.busy=false;render();msg.textContent=msg.getAttribute('data-error');});
    }
    form.addEventListener('submit',function(e){e.preventDefault();add(st.pillow);});
    var a2=$('[data-ta-atc2]',root); if(a2)a2.addEventListener('click',function(){add(st.pillow);});
    var sb=$('[data-ta-setadd]',document); if(sb)sb.addEventListener('click',function(){add(true);});

    // Livraison estimée (jours ouvrés)
    var de=$('[data-ta-date]',root);
    if(de){var n=+de.getAttribute('data-days')||6,d=new Date();while(n>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)n--;}
      try{de.textContent=d.toLocaleDateString(data.locale,{weekday:'short',day:'numeric',month:'short'});}catch(e){de.textContent=d.toLocaleDateString();}}

    // Barre d'achat fixe
    var bar=$('[data-ta-sticky]',root), main=atcs[0];
    if(bar&&main&&'IntersectionObserver' in window){new IntersectionObserver(function(es){var e=es[0];bar.classList.toggle('is-on',!e.isIntersecting&&e.boundingClientRect.top<0);}).observe(main);}
    render();markThumbs();
  }
  function init(){$$('[data-ta-product]').forEach(function(el){try{product(el);}catch(err){console.error('hm-ta',err);}});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
